import useAuthorisation from "../hooks/useAuthorisation";

export const ComponentAuthorisation = ({ children, allowedRoles }) => {
  const { authorisation } = useAuthorisation();

  const getTrueKeys = (obj) =>
    Object.keys(obj).filter((key) => obj[key] === true);

  const userRoles = getTrueKeys(authorisation?.roles);

  return (
    !authorisation.loading &&
    userRoles.find((role) => allowedRoles?.includes(role)) && <>{children}</>
  );
};

// allowfinances
// alloworders
// allowreturns
// allowstaff
// allowcontracts
// allowgeneralreports
// allowfinancialreports
// allowentitlement
// allowcheckout
// allowwardrobe
// staffAllBranches
// staffRequestCreate
// staffRequestApprove
// addressCreate
// addressEdit
// addressListCompany
// addressListBranch
// staffCreate
// staffEdit
